/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersassignmentsaved2Inputs */

const en_partnersassignmentsaved2 = /** @type {(inputs: Partnersassignmentsaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignment saved`)
};

const de_partnersassignmentsaved2 = /** @type {(inputs: Partnersassignmentsaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuordnung gespeichert`)
};

/**
* | output |
* | --- |
* | "Assignment saved" |
*
* @param {Partnersassignmentsaved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersassignmentsaved2 = /** @type {((inputs?: Partnersassignmentsaved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersassignmentsaved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersassignmentsaved2(inputs)
	return de_partnersassignmentsaved2(inputs)
});
export { partnersassignmentsaved2 as "partnersAssignmentSaved" }